import React from "react";
import '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faServer, 
  faCode, 
  faDatabase, 
  faProjectDiagram,
  faCloudUploadAlt,
  faVial,
  faShieldAlt,
  faUsers,
  faBrain,
  faTools
} from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

// Backend Development (separate)
const backendTech = [
  "C#", ".NET", "ASP.NET Core", "Entity Framework",
  "ADO.NET", "WCF", "REST", "SOAP", "Java", "API Gateway"
];

// Frontend Development (separate)
const frontendTech = [
  "Angular", "ASP.NET MVC", "TypeScript", "JavaScript", "HTML", "CSS"
];

// Databases (separate)
const databaseTech = [
  "MS SQL Server", "PostgreSQL", "SQL", "RDBMS"
];

// Architecture & Integration (separate)
const architectureTech = [
  "Microservices", "Event-Driven Architecture", "Kafka",
  "gRPC", "Distributed Systems"
];

// Cloud, DevOps & Delivery (separate)
const devopsTech = [
  "Azure DevOps", "Azure", "AWS", "CI/CD",
  "Docker", "IIS", "Kubernetes", "GitHub"
];

// Quality & Testing (separate)
const qualityTech = [
  "Unit Testing", "Integration Testing", "Automated Testing", "Production Monitoring"
];

// Security (separate)
const securityTech = [
  "OAuth2", "JWT", "Secure API Design", "OWASP"
];

// Agile & Collaboration (separate)
const agileTech = [
  "Scrum", "Cross-functional Teams", "Technical Documentation"
];

// Soft Skills (separate)
const softSkills = [
  "Critical Thinking", "Problem-Solving", "Creativity"
];


function Expertise() {
  return (
    <div className="container" id="expertise">
      <div className="skills-container">
        <h1>Expertise</h1>
        <div className="skills-grid">
          
          {/* Backend Development */}
          <div className="skill">
            <FontAwesomeIcon icon={faServer} size="3x"/>
            <h3>Backend Development</h3>
            <p>5+ years building enterprise-grade .NET backend services and RESTful APIs for high-availability financial platforms.</p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {backendTech.map((label, index) => (
                <Chip key={index} className='chip' label={label} />
              ))}
            </div>
          </div>

          {/* Frontend Development */}
          <div className="skill">
            <FontAwesomeIcon icon={faCode} size="3x"/>
            <h3>Frontend Development</h3>
            <p>Full-stack capabilities with Angular, ASP.NET MVC, and modern JavaScript for customer-facing portals.</p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {frontendTech.map((label, index) => (
                <Chip key={index} className='chip' label={label} />
              ))}
            </div>
          </div>

          {/* Databases */}
          <div className="skill">
            <FontAwesomeIcon icon={faDatabase} size="3x"/>
            <h3>Databases</h3>
            <p>Expert in MS SQL Server and PostgreSQL with query optimization, data modeling, and transaction-heavy systems.</p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {databaseTech.map((label, index) => (
                <Chip key={index} className='chip' label={label} />
              ))}
            </div>
          </div>

          {/* Architecture & Integration */}
          <div className="skill">
            <FontAwesomeIcon icon={faProjectDiagram} size="3x"/>
            <h3>Architecture & Integration</h3>
            <p>Microservices, event-driven architecture with Kafka, gRPC, and distributed systems for high-throughput workloads.</p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {architectureTech.map((label, index) => (
                <Chip key={index} className='chip' label={label} />
              ))}
            </div>
          </div>

          {/* Cloud, DevOps & Delivery */}
          <div className="skill">
            <FontAwesomeIcon icon={faCloudUploadAlt} size="3x"/>
            <h3>Cloud, DevOps & Delivery</h3>
            <p>CI/CD pipelines, containerization (Docker, Kubernetes), and cloud deployments on Azure and AWS.</p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {devopsTech.map((label, index) => (
                <Chip key={index} className='chip' label={label} />
              ))}
            </div>
          </div>

          {/* Quality & Testing */}
          <div className="skill">
            <FontAwesomeIcon icon={faVial} size="3x"/>
            <h3>Quality & Testing</h3>
            <p>Unit testing, integration testing, automated testing, and production monitoring for reliable systems.</p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {qualityTech.map((label, index) => (
                <Chip key={index} className='chip' label={label} />
              ))}
            </div>
          </div>

          {/* Security */}
          <div className="skill">
            <FontAwesomeIcon icon={faShieldAlt} size="3x"/>
            <h3>Security</h3>
            <p>OAuth2, JWT, secure API design, and OWASP best practices for protecting financial systems.</p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {securityTech.map((label, index) => (
                <Chip key={index} className='chip' label={label} />
              ))}
            </div>
          </div>

          {/* Agile & Collaboration */}
          <div className="skill">
            <FontAwesomeIcon icon={faUsers} size="3x"/>
            <h3>Agile & Collaboration</h3>
            <p>Experienced in Scrum, cross-functional teams, and technical documentation.</p>
            <div className="flex-chips">
              <span className="chip-title">Methods:</span>
              {agileTech.map((label, index) => (
                <Chip key={index} className='chip' label={label} />
              ))}
            </div>
          </div>

          {/* Soft Skills */}
          <div className="skill">
            <FontAwesomeIcon icon={faBrain} size="3x"/>
            <h3>Soft Skills</h3>
            <p>Critical thinking, problem-solving, and creativity for complex technical challenges.</p>
            <div className="flex-chips">
              <span className="chip-title">Skills:</span>
              {softSkills.map((label, index) => (
                <Chip key={index} className='chip' label={label} />
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Expertise;